import { useEffect, useState } from "react";
import { Card, Table, Modal, Button } from "react-bootstrap";
import { useQuery } from "react-query";
import { useTranslation } from "react-i18next";
// import { useMedia } from 'react-media';
import { getMessages } from "../api/api";
// import { GLOBAL_MEDIA_QUERIES } from '../constatnts';
import { IMessage } from "../types/news";

const MessageCenter = ({ limit = 5 }) => {
  const { t, i18n } = useTranslation();
  // const matches = useMedia({ queries: GLOBAL_MEDIA_QUERIES });
  const { isLoading, error, data, refetch }: any = useQuery(
    "MessagesData",
    () => getMessages({ limit, language: i18n.language })
  );

  useEffect(() => {
    refetch();
  }, [i18n.language, refetch]);

  const [showModal, setShowModal] = useState(false);
  const [selectedMessagesItem, setSelectedMessagesItem] =
    useState<IMessage | null>(null);

  const handleRowClick = (newsItem: IMessage) => {
    setSelectedMessagesItem(newsItem);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setSelectedMessagesItem(null);
  };

  if (isLoading) return <div>{t('misc.loading')}</div>;
  if (error) return <div>{t('message_center.error_loading')}</div>;

  return (
    <>
      <Card className="shadow">
        <Card.Body>
        <Card.Title>{t('message_center.title')}</Card.Title>
        <div className="table-responsive">
            {data.data.length > 0 && (
              <Table size="sm">
                <thead>
                  <tr>
                  <th>{t('message_center.day')}</th>
                  <th>{t('message_center.message')}</th>
                  </tr>
                </thead>
                <tbody>
                  {data.data.map((newsItem: IMessage) => (
                    <MessagesItem
                      key={newsItem.id}
                      data={newsItem}
                      onClick={() => handleRowClick(newsItem)}
                    />
                  ))}
                </tbody>
              </Table>
            )}
          </div>
        </Card.Body>
      </Card>

      <Modal show={showModal} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>{selectedMessagesItem?.attributes.Title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedMessagesItem?.attributes.Images.data[0] && selectedMessagesItem.attributes.Images.data[0] && (
            <img
              src={`${process.env.REACT_APP_CMS}${selectedMessagesItem?.attributes.Images?.data?.[0]?.attributes?.url ?? ''}`}
              alt={selectedMessagesItem.attributes.Title}
              className="img-fluid"
            />
          )}
          <p>{selectedMessagesItem?.attributes.SubTitle}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
          {t('misc.close')}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

interface ISMessagesItemProps {
  data: IMessage;
  onClick: () => void;
}

function formatDate(dateString: string): string {
  const date = new Date(dateString);

  const options: Intl.DateTimeFormatOptions = {
    day: "numeric",
    month: "long",
    year: "numeric",
  };
  const formattedDate = new Intl.DateTimeFormat("en-US", options).format(date);

  return formattedDate;
}

const MessagesItem = ({ data, onClick }: ISMessagesItemProps) => {
  return (
    <tr onClick={onClick}>
      <td className="calendar-view-date-cell-s">
        <div className="calendar-view-day-s en_font">
          {formatDate(data.attributes.publishedAt)}
       </div>
      </td>
      <td>
        <div className="calendar-view-subject-s">{data.attributes.Title}</div>
        <div className="calendar-view-organizer-s">{data.attributes.SubTitle}</div>
      </td>
    </tr>
  );
};

// const Title = styled.h5`
//   margin: 0;
//   font-size: 1rem;
//   font-weight: bold;
// `;

// const SubTitle = styled.p`
//   margin: 0;
//   font-size: 0.875rem;
//   color: #6c757d;
// `;

export default MessageCenter;
